import type { PaymentMethod } from '@ahm/api-wrappers-core';
import { Box, Button, Group, Image, Text, Title, rem } from '@mantine/core';
import { closeAllModals, type ContextModalProps } from '@mantine/modals';
import { setCookie } from 'cookies-next';
import { useTranslations } from 'next-intl';
import { useEffect } from 'react';
import { ModalName } from '@/components/modals';
import useIsMobile from '@/lib/is-mobile/use-is-mobile';
import { useLocaleSuffix } from '@/navigation';

type ModalNotiCashByRecipientProps = {
  method: PaymentMethod;
};
const ModalNotiCashByRecipient = ({
  innerProps,
}: ContextModalProps<ModalNotiCashByRecipientProps>) => {
  const { method } = innerProps;
  const isMobile = useIsMobile();
  const localSuffix = useLocaleSuffix();

  const tPayment = useTranslations('payment');
  const tCommon = useTranslations('common');

  useEffect(() => {
    void setCookie(ModalName.NotiCashByRecipient, true);
  }, []);

  const handleClose = () => {
    closeAllModals();
  };

  return (
    <>
      <>
        <Group
          // position="apart"
          w="100%"
          p={isMobile ? rem(12) : rem(24)}
          bg="white"
          pos={isMobile ? 'fixed' : 'sticky'}
          top={0}
          right={0}
          left={0}
          justify="center"
        >
          {method.icon_url && (
            <Image
              width={110}
              height={110}
              src={method.icon_url}
              alt={method.icon_url}
            />
          )}
        </Group>

        <Box
          style={{
            flex: '1 1 auto',
            ...(isMobile
              ? {
                  width: '100%',
                  position: 'fixed',
                  overflowY: 'auto',
                  overflowX: 'hidden',
                  height: 'auto',
                  top: 168,
                  bottom: 0,
                }
              : {}),
          }}
          p={isMobile ? rem(12) : rem(24)}
          pt={0}
          bg={'white'}
        >
          <Title ta="center" order={4} c="neutral.7">
            {method[`name_${localSuffix}`]}
          </Title>
          <Text mt={12} ta="center" c="neutral.5">
            {tPayment('cash.cash_by_recipient_desc')}
          </Text>
        </Box>

        <Box
          pos={isMobile ? 'fixed' : 'sticky'}
          right={0}
          bottom={0}
          left={0}
          w="100%"
          p="md"
          bg="white"
        >
          <Button radius="md" size="lg" fullWidth onClick={handleClose}>
            {tCommon('got_it')}
          </Button>
        </Box>
      </>
    </>
  );
};

export default ModalNotiCashByRecipient;
